module.exports = __webpack_public_path__ + "static/media/warning.4cc21b94.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/res/images/discordAssets/warning.svg
// module id = 1083
// module chunks = 21